module.exports = __webpack_public_path__ + "img/grief.3a727cd0.svg";